export default {
  props: {
    label: {
      type: String,
      required: false,
      default: () => { return null }
    },
    inputClass: {
      type: [Object, String],
      required: false,
      default: () => { return null }
    },
    genericErrorMsg: {
      type: String,
      required: false,
      default: () => { return null }
    },
    form: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    errorBag: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },

  data () {
    return {
      isDirty: false
    }
  },

  computed: {
    propPath: {
      get: function () {
        return this.prop.split('.').reduce((o, i) => o[i], this.form)
      },
      set: function (newValue) {
        this.isDirty = true
        this.setPropObj(this.form, this.prop, newValue)
      }
    },

    attributes () {
      return {
        ...this.defaultAttributes ? this.defaultAttributes : {},
        ...this.$attrs
      }
    },

    validationName () {
      if (this.attributes['validation-name']) {
        return this.attributes['validation-name']
      }
      if (this.attributes.name) {
        var name = this.attributes.name.replace(/_/g, ' ')
        return name.charAt(0).toUpperCase() + name.slice(1)
      }
      if (this.prop) {
        var prop = this.prop.replace(/_/g, ' ')
        return prop.charAt(0).toUpperCase() + prop.slice(1)
      }
    },

    getErrorMessage () {
      if (this.errorBag[this.prop]) {
        return this.errorBag[this.prop]
      }
      return this.prop.split('.').reduce((o, i) => o[i], this.errorBag)
    },

    classNames () {
      var defaultLoadedClassObject = {}
      defaultLoadedClassObject[this.inputClass] = true
      var loadedClass = (typeof this.inputClass === 'object') ? this.inputClass : defaultLoadedClassObject

      var defaultClassObject = {}
      defaultClassObject[this.defaultClassNames] = true
      var defaultClassNames = (typeof this.defaultClassNames === 'object') ? this.defaultClassNames : defaultClassObject

      return {
        ...defaultClassNames,
        ...{ 'form-control': true, 'is-invalid': this.hasKey(this.errorBag, this.prop) && this.isDirty, 'is-valid': !this.hasKey(this.errorBag, this.prop) && this.propPath },
        ...loadedClass
      }
    }
  },

  mounted () {
    if (this.my360FormErrors[this.prop]) {
      this.isDirty = true
    }
  },

  methods: {
    setPropObj (obj, is, value) {
      if (typeof is === 'string') {
        return this.setPropObj(obj, is.split('.'), value)
      } else if (is.length === 1 && value !== undefined) {
        this.$set(obj, is[0], value)
        return obj
      } else if (is.length === 0) {
        return obj
      } else {
        return this.setPropObj(obj[is[0]], is.slice(1), value)
      }
    }
  }
}
